module.exports = __webpack_public_path__ + "img/QU.53607f71.png";